// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"40b250a4","174":"40b250a4","264":"06787e74","276":"40b250a4","422":"bd86bff3"}[chunkId] + ".chunk.css";
};